<template>
  <div>
    <vue-editor class="editor" name="description" v-model="content"
      :customModules="[
      ]"
      :editorOptions="{
        modules:{
          toolbar: {
            container: '#toolbar-container'+_uid,
            handlers: {
//              dice: diceHandler
            }
          }
        },
        theme: 'snow'
      }"
      @focus="open=true"
      @blur="open=false"
    >
      <template v-slot:toolbar>
        <transition name="fade">
          <div :id="'toolbar-container'+_uid" v-show="open" @click="open=true">
            <span class="ql-formats">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
              <button class="ql-strike"></button>
            </span>
            <!-- <span class="ql-formats">
              <select class="ql-align"></select>
            </span> -->
            <span class="ql-formats">
              <select class="ql-size">
                <option value="small"></option>
                <option selected></option>
                <option value="large"></option>
                <option value="huge"></option>
              </select>
            </span>
            <span class="ql-formats" v-if="counter">
              <button :id="'counter'+_uid" style="width:60px">
                <div style="display:inline-block;">
                  <vue-twitter-counter style="display:inline-block;" 
                    :current-length="contentLength" 
                    :warnLength="warn"
                    :dangerAt="danger"
                  />
                </div>
              </button>
            </span>
            <!-- <span class="ql-formats">
                <button class="ql-image"></button>
                <button class="ql-dice"></button>
            </span> -->
          </div>
        </transition>
      </template>
    </vue-editor>
  </div>
</template>

<script>
import VueTwitterCounter from 'vue-twitter-counter'
// import { DiceHandler } from './editor/dice'

export default {
  name: 'remark-editor',
  components: { VueTwitterCounter },
  computed: {
    contentLength () {
      return (this.content||'')
        .replace(/<\/p>|(<p>)?<br>(<\/p>)?/g,'\n')
        .replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
        .length
    }
    // diceHandler () { return DiceHandler }
  },
  data () {
    return {
      content: this.value,
      open: false
    }
  },
  watch: {
    content (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.content = val
    }
  },
  props: {
    value: String,
    danger: { type:Number, default:200 },
    warn: { type:Number, default:100 },
    counter: { type:Boolean, default:true }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}
.fade-enter, .fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.editor {
  background-color: #FFF;
  border: solid 1px #CCC;
  border-top: solid 5px #CCC;

  ::v-deep .ql-editor{
    min-height: 100px;

    .ql-dice {
      background: #30C;
      color: #FFF;
      padding: 5px;

      padding: 0.25em 0.5em;
      text-decoration: none;
      border-bottom: solid 2px #10A;
      border-radius: 4px;
      box-shadow: inset 0 2px 0 rgba(255,255,255,0.2), 0 2px 2px rgba(0, 0, 0, 0.19);
      font-weight: bold;
    }
    .ql-dice :after{
      content: '🎲'
    }
  }

}
</style>
